module.exports = __webpack_public_path__ + "static/media/first-line.2ab1f9a4.svg";